import { ModelRow } from "@mcleod/core";
import { AutogenLayoutInvoiceProcessingExceptionTable } from "./autogen/AutogenLayoutInvoiceProcessingExceptionTable";

export class InvoiceProcessingExceptionTable extends AutogenLayoutInvoiceProcessingExceptionTable {
    public set data(data: any[]) {
        const modelRowArray: ModelRow[] = [];
        data?.forEach(row => {
            const modelRow = new ModelRow("lme/ar/reports/invoice-processing-exception", false, { ...row });
            modelRowArray.push(modelRow);
        });
        this.sourceInvoiceProcessingException.data = modelRowArray;
        this.sourceInvoiceProcessingException.displayDataInBoundComponents();
    }
}
